var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floating-menu"},[_c('ul',{staticClass:"list"},_vm._l((_vm.list),function(item,index){return _c('li',{key:`floating_${index}`,staticClass:"item",on:{"click":function($event){$event.stopPropagation();return item.clickEv.apply(null, arguments)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }